import { render, staticRenderFns } from "./TaskCreateDialogTest.vue?vue&type=template&id=489e1450&"
import script from "./TaskCreateDialogTest.vue?vue&type=script&lang=js&"
export * from "./TaskCreateDialogTest.vue?vue&type=script&lang=js&"
import style0 from "./TaskCreateDialogTest.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TaskCreateDialogTest.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports